@let isExperianCompany = isExperianCompany$ | async;

<div class="h-100 color-dark overflow-auto">
  <div class="flex-column gap-5 h-100">
    <button
      pButton
      type="button"
      class="p-button p-button-primary p-button-outlined small icon-only back-button"
      (click)="goToLoginPage()">
      <shared-icon icon="triangle-left" height="1rem" width="1rem" class="fill-dark" />
    </button>
    <div class="text-28 bold-800 text-center color-dark">Welcome to your new Mortgage Monitor</div>
    <div class="flex-column gap-5 h-100">
      @if (isExperianCompany) {
        <ng-container *ngTemplateOutlet="experianTermsAndConditions" />
      } @else {
        <ng-container *ngTemplateOutlet="defaultTermsAndConditions" />
      }
    </div>
  </div>
</div>

<ng-template #defaultTermsAndConditions>
  <p class="text-18 text-center line-height-130">
    As part of our ongoing commitment to providing you with expert advice, we monitor your mortgage
    24/7 to ensure that you’re always on the deal that’s best suited to your circumstances.
  </p>
  <div class="flex-column gap-3">
    <div class="flex gap-3">
      <div class="third-party-getting-started-item-icon-container">
        <shared-icon class="fill-dark" icon="mortgage" height="2rem" width="2rem" />
      </div>
      <span class="text-16 line-height-150">
        <span class="bold">Track the equity</span>
        that's building up in your property and send you monthly reports
      </span>
    </div>
    <div class="flex gap-3">
      <shared-icon class="fill-dark" icon="notification" height="2rem" width="2rem" />
      <span class="text-16 line-height-150">
        <span class="bold">Notify you</span>
        the moment there is a better rate your rate changes or comes to an end
      </span>
    </div>
    <div class="flex gap-3">
      <shared-icon class="fill-dark" icon="file-with-magnifying-glass" height="2rem" width="2rem" />
      <span class="text-16 line-height-150">
        <span class="bold">Challenge your</span>
        current mortgage deal against thousands of other products
      </span>
    </div>
  </div>
  <form [formGroup]="acceptedTermsAndConditionsForm" (ngSubmit)="agreeAndLogin(false)">
    <div class="consent-container mt-auto">
      @if (company$ | async; as company) {
        <div>
          <div class="flex gap-2 align-items-center">
            <cp-checkbox [formControl]="acceptedTermsAndConditionsForm.controls.agreeTerms" />
            @if (company.companyClientUISettings.consentScreenText) {
              <span
                class="terms-and-conditions-label"
                [innerHTML]="
                  addClassAndTargetToInnerHtmlConsentText(
                    company.companyClientUISettings.consentScreenText
                  )
                "></span>
            } @else {
              <span class="terms-and-conditions-label">
                I agree to
                <a class="underline" target="_blank" [href]="tacLink">Terms of Use</a>
                and
                <a class="underline" target="_blank" [href]="privacyPolicyLink">Privacy Policy</a>
              </span>
            }
          </div>
          <div class="text-14 color-red mt-1">
            @if (showWarnState()) {
              You have to agree with Terms of Use and Privacy Policy
            }
          </div>
        </div>
        <button
          pButton
          class="p-button p-button-primary w-100 centered"
          type="submit"
          [disabled]="acceptedTermsAndConditionsForm.invalid"
          [loading]="loading$ | async">
          Continue
        </button>
      }
    </div>
  </form>
</ng-template>

<ng-template #experianTermsAndConditions>
  <div class="text-18 text-center line-height-130">
    We’ve created your personalised Mortgage Monitor to help you stay on top of your mortgage and
    make sure you’re always on the best deal for your needs.
  </div>

  <div class="bold">What You’ll get:</div>

  <div class="flex-column gap-3">
    <div class="flex gap-3">
      <div>
        <shared-icon class="fill-dark" icon="mortgage" height="2rem" width="2rem" />
      </div>
      <div class="text-16 line-height-150">
        <div class="bold">Your Mortgage Dashboard</div>
        <div>
          View all your mortgage and property details in one place—including your current property
          value and equity.
        </div>
      </div>
    </div>
    <div class="flex gap-3">
      <div>
        <shared-icon class="fill-dark" icon="notification" height="2rem" width="2rem" />
      </div>
      <div class="text-16 line-height-150">
        <div class="bold">Ongoing Mortgage Monitoring</div>
        <div>
          We’ll regularly compare your mortgage against thousands of deals from over 90 lenders.
        </div>
      </div>
    </div>
    <div class="flex gap-3">
      <div>
        <shared-icon
          class="fill-dark"
          icon="file-with-magnifying-glass"
          height="2rem"
          width="2rem" />
      </div>
      <div class="text-16 line-height-150">
        <div class="bold">Money-Saving Alerts</div>
        <div>
          Get timely notifications when a better rate is available, your rate changes, or your deal
          is ending.
        </div>
      </div>
    </div>
    <div class="text-14 text-justify line-height-130">
      We use your personal data to provide this service, including mortgage details, property value
      estimates, and alerts about better deals. This is a test feature. You can opt out of emails at
      any time, but you’ll still have access to your Mortgage Dashboard. Using your personal
      information is necessary to deliver this service as part of our agreement with you.
      <br />
      <br />
      By selecting Continue, you agree to Experian providing the Mortgage Monitor service as
      described above
    </div>
    <button
      pButton
      class="p-button p-button-primary w-100 centered"
      type="button"
      [loading]="loading$ | async"
      (click)="agreeAndLogin(true)">
      Continue
    </button>
  </div>
</ng-template>
